import { defineStore } from 'pinia';
import { store } from '@/stores';
import { ref } from 'vue';
import globalTool from '@/utils/globalTool';
import type { AddressInfo, RewardInfo } from '@/api/types';
import { getBaseSiteInfo, getIndexConfig, getMemberInfo, type BaseSiteInfoData, type IndexConfigData, type MemberBasicInfo } from '@/api/index2';

export const useUserStore = defineStore('user', () => {
    // state
    const userId = ref();
    const baseURL = import.meta.env.VITE_APP_BASE_URL;

    let wxCode = ref(); //服务器用来获取用户搜索历史记录的唯一id
    const chanyeRange = ref<Array<Object>>([]); // 用户权限编码集合 → 判断按钮权限
    let currentDomain = window.location.origin;
    if(currentDomain.includes('localhost')){
        currentDomain = "";
    }
    const url = location.origin.indexOf('http://localhost')>-1 ? baseURL+'/' : location.origin + '/';

    // const yzmurl = location.origin +'/api/api/captcha?key=' ;
    const yzmurl = location.origin.indexOf('http://localhost')>-1 ? location.origin +'/api/api/captcha?key=' : location.origin + '/api/captcha?key=';

    const prefixUrl = ref(import.meta.env.VITE_APP_BASE_URL || currentDomain );
    const userdetail = ref<any>({});
    const showRecharge = ref(true);
    //图片前缀url
    function getOpenID() {
        uni.login({
            provider: 'weixin', //使用微信登录
            success: function (res) {
                console.log(res);
            },
            fail: function (res) {
                console.log('err', res);
            }
        });
    }
    const siteInfo = ref<BaseSiteInfoData | null>(null);
    /**
     * @param {LoginData}
     * @returns
     */
    function reqSiteInfo() {
        return new Promise<void>((resolve, reject) => {
            getBaseSiteInfo().then((res: any) => {
                siteInfo.value = res;
                resolve();
            }).catch((err: any) => {
                console.log("服务器基本信息获取失败", err);
            });
        });
    }

    const assetType = ref(0);
    function setAssetType(type: number) {
        assetType.value = type;
    }
    const rewardInfo = ref<RewardInfo>({} as RewardInfo);
    function setRewardInfo(info: RewardInfo) {
        rewardInfo.value = info;
    }
    const userInfo = ref<MemberBasicInfo>()
    function reqUserInfo(){
        getMemberInfo()
        .then((res: any) => {
            userInfo.value = res;
        })
        .catch((err: any) => {
            console.log("个人基本信息获取失败", err);
        });
    }
    function reqConfigInfo(){
        getIndexConfig()
        .then((res: any) => {
            configInfo.value = res;
        })
        .catch((err: any) => {
            console.log("配置信息获取失败", err);
        });
    }
    const configInfo = ref<IndexConfigData>({} as IndexConfigData);

    return {
        reqUserInfo,
        userInfo,
        chanyeRange,
        reqSiteInfo,
        siteInfo,
        userId,
        wxCode,
        getOpenID,
        prefixUrl,
        url,
        userdetail,
        yzmurl,
        assetType,
        setAssetType,
        rewardInfo,
        setRewardInfo,
        showRecharge,
        reqConfigInfo,
        configInfo
    };
});

// 非setup
export function useUserStoreHook() {
    return useUserStore(store);
}
